
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/art-for-impact-creativity",
      function () {
        return require("private-next-pages/art-for-impact-creativity/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/art-for-impact-creativity"])
      });
    }
  